import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash-es';

import { FulfillmentPlanService } from '../../../services/fulfillment-plan-service';
import { FulfillmentPlanOrderGridStatus } from '../../../enums/fulfillmentplan-order-grid-status';
import Global from '../../../store/global-selectors';
import { Container as CustomsWidgetContainer } from '../../../components/customs-declarations/container';

const mapStatesToOrder = (state) => {
  const fulfillmentPlanIdsInDrawer = Global.selectSelectedOrdersIds(state);
  const salesOrder = Global.selectEntitiesSalesOrdersByFulfillmentPlanIds(state, { fulfillmentPlanIds: fulfillmentPlanIdsInDrawer })[0];
  return salesOrder;
};

const mapStateToProps = (state) => {
  const salesOrder = mapStatesToOrder(state);
  const salesOrderId = get(salesOrder, 'salesOrderId');
  const isCreatingReturn = Global.selectOrderDetailsIsCreatingReturn(state);
  const returnFulfillmentPlanId = isCreatingReturn ? Global.selectOrdersDrawerReturnsFulfillmentPlanId(state, { salesOrderId }) : undefined;
  const [selectedFulfillmentPlanId] = Global.selectSelectedOrdersIds(state);
  const fulfillmentPlanId = isCreatingReturn ? returnFulfillmentPlanId : selectedFulfillmentPlanId;
  const fulfillmentPlan = Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId }) || {};
  const { orderGridStatus } = fulfillmentPlan;
  const isShipped = orderGridStatus === FulfillmentPlanOrderGridStatus.Shipped.name;
  const shouldShowShipmentWidget = FulfillmentPlanService.shouldShowShipmentWidget(fulfillmentPlan);
  const shouldShowCustoms = shouldShowShipmentWidget || isShipped;

  return {
    fulfillmentPlanId,
    shouldShowCustoms,
    readOnly: isShipped,
  };
};

const CustomsWidgetContainerDisplay = (props) => {
  if (!props.shouldShowCustoms) {
    return null;
  }

  return <CustomsWidgetContainer {...props} />;
};

CustomsWidgetContainerDisplay.propTypes = {
  shouldShowCustoms: PropTypes.bool,
};

export const CustomsSectionContainer = connect(mapStateToProps);

export const Customs = CustomsSectionContainer(CustomsWidgetContainerDisplay);
